import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { SectionWrapperComponent } from '../section-wrapper/section-wrapper.component';
import { CtaButtonComponent } from '../cta-button/cta-button.component';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-quote-request',
  imports: [SectionWrapperComponent, CtaButtonComponent],
  templateUrl: './quote-request.component.html',
  styleUrl: './quote-request.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuoteRequestComponent {
  private readonly siteConfig = inject(SiteConfigService);

  readonly section = this.siteConfig.quoteRequest;
}
